/*
    Accordions
*/
function initAccordions() {
    // Find and iterate through all of the uninitialized accordions
    let didInitialize = false;
    let pageAccordions = document.querySelectorAll('.js-accordion-button:not([data-init="true"])');
    if(pageAccordions !== null && pageAccordions.length) {
        didInitialize = true;
        pageAccordions.forEach(function (accordion, index) {
            // See if it has a valid cotnent section
            let accordionContent = accordion.parentNode.querySelector(".js-accordion-content");
            if(accordionContent !== null) {
                // Set up the properties
                accordion.setAttribute("aria-expanded", false);
                let ran = Math.floor(Math.random() * 10000000000000);
                accordion.setAttribute("aria-controls", "ac_"+ran);
                accordion.setAttribute("id", "ach_"+ran);
                accordionContent.setAttribute("id", "ac_"+ran);
                accordionContent.setAttribute("aria-labeledby", "ach_"+ran);

                // Attach the click events
                accordion.addEventListener("click", function(event) {
                    this.parentNode.classList.toggle("active");
                    vSlideToggle(accordionContent);
                    if(this.getAttribute("aria-expanded") == "true") {
                        this.setAttribute("aria-expanded", "false");
                    } else {
                        this.setAttribute("aria-expanded", "true");
                    }
                });

                // Hide all accordion content on page load
                if(accordion.parentElement.classList.contains("js-mobile-only")) {
                    if(window.innerWidth < tablet_break) {
                        accordionContent.style.display = "none";
                    }
                    window.addEventListener("resize", function() {
                        if(window.innerWidth >= tablet_break && accordion.parentElement.classList.contains("js-mobile-only") && (accordion.style.display == "none" || getComputedStyle(accordion).display == "none")) {
                            accordionContent.style.display = "block";
                        } else if(window.innerWidth < tablet_break && accordion.parentElement.classList.contains("js-mobile-only") && !accordion.parentElement.classList.contains("active") && (accordion.style.display == "block" || getComputedStyle(accordion).display == "block")) {
                            accordionContent.style.display = "none";
                        }
                    });
                } else {
                    accordionContent.style.display = "none";
                }

                // Set a property of the accordion so we can tell it was initialized. Accordions without this property will be initialized by initAccordions();
                accordion.setAttribute("data-init", true);
            }
        });
    }
    return didInitialize;
}
// Accordion Script -- fire if accordions exist
initAccordions();


/*
    Tabs
*/
function initTabs() {
    // Find and iterate through all of the uninitialized accordions
    let didInitialize = false;
    let pageTabAreas = document.querySelectorAll('.js-tabs-area:not([data-init])');
    if(pageTabAreas !== null && pageTabAreas.length) {
        didInitialize = true;
        for(i = 0; i < pageTabAreas.length; i++) {
            // Set up the properties
            let area = pageTabAreas[i];
            let header = "";
            let showFirst = true;
            if(pageTabAreas[i].classList.contains("js-tabs-closed")) {
                showFirst = false;
            }

            // Go through each set of tabs
            var tabs = pageTabAreas.querySelectorAll(".js-tab");
            if(tabs !== null && tabs.length) {
                for(j = 0; j < tabs.length; j++) {
                    //Combine tab headers to display as header
                    tabs[j].getElementsByClassName("js-tab-header")[0].setAttribute("data-tab", j).setAttribute("role", "tab");
                    if(j==0 && showFirst) {
                        tabs[j].getElementsByClassName("js-tab-header")[0].setAttribute("data-tab", j).setAttribute("aria-selected", true).classList.add("current");
                    }
                    header += tabs[j].getElementsByClassName("js-tab-header")[0].outerHTML;
                    //Hide all tab headers
                    vHide(tabs[j].getElementsByClassName("js-tab-header")[0]);

                    //index tab content and hide
                    $(this).find(".js-tab-content").attr("data-tab",i).attr("role","tabpanel");
                    if(i!=0 || !showFirst) {
                        $(this).find(".js-tab-content").attr("aria-hidden", true);
                        $(this).find(".js-tab-content").hide();
                    }
                }
            }

            //Build header
            area.innerHTML = "<div class='js-tab-nav tab-nav' role='tablist'>"+header+"</div>"+area.innerHTML;
            var revealTabs = getParentElementWithClass(pageTabAreas[i], "reveal-tabs");
            if(revealTabs !== null && revealTabs.length) {
                pageTabAreas[i].querySelector(".js-tab-nav .js-tab-header:first").click();
            }

            // Set a property of the tabs so we can tell it was initialized. Tabs without this property will be initialized by initTabs();
            pageTabAreas[i].setAttribute("data-init", "true");
        }

        //Click Events for Tabs
        var navTabs = document.querySelectorAll(".js-tab-nav .js-tab-header:not([data-init])");
        if(navTabs !== null && navTabs.length) {
            for(i = 0; i < navTabs.length; i++) {
                navTabs[i].addEventListener("click", function(event) {
                    if(navTabs[i].classList.contains("current")) {
                        // Code to hide tab content as a toggle when the active tab is clicked again while still active.
                    } else {
                        // Following 2 lines replace this: $(this).closest(".js-tabs-area").addClass("active");
                        var tabArea = getParentElementWithClass(navTabs[i], "js-tabs-area");
                        if(tabArea !== null) {
                            tabArea.classList.add("active");
                        }
                        //remove current from all header links
                        var slide = false;
                        if(navTabs[i].parentElement.querySelector(".js-tab-header.current").length < 1) {
                            slide = true;
                        }
                        navTabs[i].parentElement.getElementsByClassName("js-tab-header")[0].removeAttribute("aria-selected").classList.remove("current");
                        vHide(navTabs[i].parentElement.parentElement.getElementsByClassName("js-tab-content")[0]);
                        navTabs[i].parentElement.parentElement.getElementsByClassName("js-tab-content")[0].setAttribute("aria-hidden", true);
                        //show clicked tab
                        navTabs[i].setAttribute("aria-selected", true).classList.add("current");
                        if(false) {
                            vSlideDown(navTabs[i].parentElement.parentElement.querySelector(".js-tab-content[data-tab='"+navTabs[i].getAttribute("data-tab")+"']"));
                            navTabs[i].parentElement.parentElement.querySelector(".js-tab-content[data-tab='"+navTabs[i].getAttribute("data-tab")+"']").removeAttribute("aria-hidden");
                        } else {
                            vshow(navTabs[i].parentElement.parentElement.querySelector(".js-tab-content[data-tab='"+navTabs[i].getAttribute("data-tab")+"']"));
                            navTabs[i].parentElement.parentElement.querySelector(".js-tab-content[data-tab='"+navTabs[i].getAttribute("data-tab")+"']").removeAttribute("aria-hidden");
                        }
                    }
                    //scroll trigger of parallax and owl
                    window.dispatchEvent(new Event('scroll'));
                    window.dispatchEvent(new Event('resize'));
                });

                // Set a property of the tabs so we can tell it was initialized. Tabs without this property will be initialized by initTabs();
                navTabs[i].setAttribute("data-init", "true");
            }
        }
    }
    return didInitialize;
}
// Tabs Script -- fire if accordions exist
initTabs();


/*
    Homepage Feature Carousel
*/
var homepageFeature = document.querySelectorAll(".mod-feature.splide");
if (homepageFeature.length > 0) {
    homepageFeature.forEach(function (carousel) {
        new Splide(carousel, {
            type    : 'loop',
            perPage : 1,
            autoplay: 'play',
        }).mount();
    });
}


/*
    Large Colored Circle Carousel Block
*/
var largeColoredCircleBlocks = document.querySelectorAll(".colored-circles.splide");
if (largeColoredCircleBlocks.length > 0) {
    largeColoredCircleBlocks.forEach(function (carousel) {
        new Splide(carousel, {
            destroy     : true,
            breakpoints : {
                900: {
                    destroy : false,
                    type    : 'loop',
                    perPage : 1,
                    gap     : '2em',
                    padding : 'calc(50% - 136px)',
                    arrows  : false,
                },
            }
        }).mount();
    });
}


/*
    Branch Filtering
    !!! (╯°□°)╯︵ ┻━┻ !!!
*/
function adjustFilterTrack() {
    var locationFilters = document.querySelectorAll(".mod-location-listing .filter-content");
    if (locationFilters.length > 0) {
        locationFilters.forEach(function (filter, index) {
            filter.querySelector(".js-filter-track.mobile .js-filter-indicator").style.width = String(filter.querySelector(".js-filter-button.current").offsetWidth) + "px";
            filter.querySelector(".js-filter-track.mobile .js-filter-indicator").style.left = String(filter.querySelector(".js-filter-button.current").offsetLeft) + "px";
            filter.querySelector(".js-filter-track.desktop .js-filter-indicator").style.width = String(filter.querySelector(".js-filter-button.current").offsetWidth) + "px";
            filter.querySelector(".js-filter-track.desktop .js-filter-indicator").style.left = String(filter.querySelector(".js-filter-button.current").offsetLeft) + "px";
            if(window.innerWidth < tablet_break) {
                let filterButtons = filter.querySelectorAll(".js-filter-button");
                let mobileFilterTrack = filter.querySelector(".js-filter-track.mobile");
                let trackWidth = 0;
                if(filterButtons.length > 0) {
                    filterButtons.forEach(function (button, index) {
                        trackWidth = trackWidth + button.offsetWidth;
                    });
                }
                mobileFilterTrack.style.width = "calc(" + String(trackWidth) + "px + 0.15em + (2em * " + String(filterButtons.length - 1) + "))";
            }
        });
    }
}
function filterLocations(filterId) {
    // Set the clicked button as current, de-select the rest
    activeButton = document.querySelector(".js-filter-button[data-filter=\"" + filterId + "\"]");
    let filterButtons = document.querySelectorAll(".js-filter-button");
    filterButtons.forEach(function (button) {
        button.classList.remove("current");
    });

    activeButton.classList.add("current");
    adjustFilterTrack();

    // Show the matching branches, hide the rest
    let locationContainer = getParentElementWithClass(activeButton, "mod-location-listing");
    let locationList = locationContainer.querySelectorAll(".location");
    locationList.forEach(function (location) {
        if(location.getAttribute("data-filters").toString().includes(filterId)) {
            vShow(location, "flex");
        } else {
            vHide(location);
        }
    });

    // Assuming the filter ID is valid, store it in a cookie so that it persists.
    if(filterId === "all" && !locationContainer.classList.contains('mod-blog-listing')) {
        clearCookie("pm_location_filter");
    } else if("" !== filterId && null !== filterId && undefined !== filterId) {
        setCookieValue("pm_location_filter", filterId, 30);
    }
}
var locationFilters = document.querySelectorAll(".mod-location-listing .filter-content");
if (locationFilters.length > 0) {
    locationFilters.forEach(function (filter, index) {
        let filterButtons = filter.querySelectorAll(".js-filter-button");
        let mobileFilterTrack = filter.querySelector(".js-filter-track.mobile");
        let trackWidth = 0;
        if(filterButtons.length > 0) {
            filterButtons.forEach(function (button, index) {
                trackWidth = trackWidth + button.offsetWidth;
                button.addEventListener("click", function(event) {
                    filterLocations(event.target.getAttribute("data-filter"));
                });
            });
        }
        window.addEventListener("resize", function() {
            adjustFilterTrack();
        });
        window.addEventListener('load', (event) => {
            adjustFilterTrack();
            window.dispatchEvent(new Event('resize'));
        });
    });

    // First time this is executed, check to see if there's a filter set in cookies.
    // If so, filter on execute.
    if(getCookieValue("pm_location_filter") !== "") {
        filterLocations(getCookieValue("pm_location_filter"));
    }
}


/*
    Open tabs or accordions if they match the URL's anchor
*/
let urlHashAccordion = "";
if(URLHASH !== "") {
    hashAccordionButton = document.querySelector(URLHASH + ' > .js-accordion-button');
}
if(URLHASH !== "" && hashAccordionButton !== "" && hashAccordionButton !== null && hashAccordionButton.style.display !== "none" && getComputedStyle(hashAccordionButton).display !== "none") {
    hashAccordionButton.click();
}


/*
    Force scroll to anchor on load
*/
window.onload = function (event) {
    if(window.location.hash != "" && document.getElementById(window.location.hash.substring(1)) != null) {
        window.setTimeout(function() {
            let top = document.getElementById(window.location.hash.substring(1));
            top.scrollIntoView({ behavior: 'smooth'});
        }, 600);
    }
};


/* Compare Tables */
function initComparisonTables() {
    // Find and iterate through all of the uninitialized accordions
    let didInitialize = false;
    let compareTables = document.querySelectorAll('.js-comparison-table:not([data-init="true"])');
    if(compareTables !== null && compareTables.length) {
        didInitialize = true;
        compareTables.forEach(function (table, index) {
            // Identify container to append elements to
            let tableContainer = table.querySelector('.js-table-container');
            // Identify the container
            let tableControlsDots = table.querySelector('.table-controls-dots');
            // Identify number of columns
            let tableCols = table.querySelectorAll('.mod-comparison-table table tr:first-child th').length;
            // Identify all of the rows we need to iterate through
            let tableRows = table.querySelectorAll('.mod-comparison-table tr');
            // Product Titles
            let tableTitles = [];

            // The title field for the account name in the arrow controls
            let tableControlsTitle = table.querySelector(".js-account-title");

            // Previous Button
            let tableNextButton = table.querySelector('.js-prev-account');
            tableNextButton.addEventListener("click", function(e) {
                let theTable = getParentElementWithClass(e.target, 'js-comparison-table');
                tablePrev(theTable, parseInt(theTable.getAttribute('data-current-position')));
            });

            // Next Button
            let tablePrevButton = table.querySelector('.js-next-account');
            tablePrevButton.addEventListener("click", function(e) {
                let theTable = getParentElementWithClass(e.target, 'js-comparison-table');
                tableNext(theTable, parseInt(theTable.getAttribute('data-current-position')));
            });

            // Adding data attributes for the cells
            for(i = 1; i < tableCols; i++) {
                tableTitles.push(tableRows[0].querySelectorAll('th')[i].innerText);
                table.querySelectorAll('.mod-comparison-table tr > *:nth-child(' + (i + 1) + ')').forEach(function (cell, index) {
                    cell.setAttribute('data-pos', i);
                });
                if(i == 1) {
                    tableControlsTitle.innerText = tableTitles[i - 1];
                }
            }

            // Carousel Dots
            tableTitles.forEach(function (title, index) {
                // Prev Button
                let carouselDot = document.createElement('li');
                let activeDot = "";
                if(index == 0) {
                    activeDot = " is-active";
                }
                carouselDot.innerHTML = '<button class="carousel-dot js-carousel-dot' + activeDot + '" type="button" data-pos="' + (index + 1) + '"><span class="visuallyhidden">View ' + title + ' Features</span></button>';
                tableControlsDots.append(carouselDot);
                carouselDot.addEventListener("click", function(e) {
                    tableSwitch(getParentElementWithClass(e.target, 'js-comparison-table'), parseInt(e.target.getAttribute('data-pos')));
                });
            });

            // Set the first product as active
            let firstCells = table.querySelectorAll('.mod-comparison-table tr > *:nth-child(2)');
            firstCells.forEach(function (cell, index) {
                cell.classList.add('active');
            });

            table.setAttribute('data-init', 'true')
            table.setAttribute('data-current-position', 1);
        });
    }
    return didInitialize;
}
// Initialize the tables
initComparisonTables();
// Click Events
function tablePrev(tableElem, currentIndex) {
    let newIndex = currentIndex - 1;
    let tableCols = tableElem.querySelectorAll('table tr:first-child > *').length;
    if(newIndex == 0) {
        newIndex = tableCols - 1;
    }
    tableSwitch(tableElem, newIndex);
}
function tableNext(tableElem, currentIndex) {
    let newIndex = currentIndex + 1;
    let tableCols = tableElem.querySelectorAll('table tr:first-child > *').length;
    if(newIndex == tableCols) {
        newIndex = 1;
    }
    tableSwitch(tableElem, newIndex);
}
function tableSwitch(tableElem, posNumber) {
    let oldCells = tableElem.querySelectorAll('th, td');
    oldCells.forEach(function (cell, index) {
        cell.classList.remove('active');
    });
    let newCells = tableElem.querySelectorAll('tr > *:nth-child(' + (parseInt(posNumber) + 1) + ')');
    newCells.forEach(function (cell, index) {
        cell.classList.add('active');
    });
    let carouselDots = tableElem.querySelectorAll('.js-carousel-dot');
    carouselDots.forEach(function (dot, index) {
        dot.classList.remove('is-active');
    });
    carouselDots[posNumber - 1].classList.add('is-active');
    tableElem.setAttribute('data-current-position', posNumber);
    tableElem.querySelector('.js-account-title').innerText = tableElem.querySelector('tr:first-child > *:nth-child(' + (parseInt(posNumber) + 1) + ')').innerText;
}
